import i18n from "@/i18n";
import SocketController from "@/services/Socket/socket.controller";
import { SendRegisterUser } from "@/types";

export async function sendRegisterUser(
  newUserDetails: SendRegisterUser
): Promise<
  | {
      rStatus: "success";
    }
  | {
      rStatus: "error";
      rData: string;
    }
> {
  console.log(`Sending register user command`);
  console.log("New User Details:", newUserDetails);
  try {
    const response = await SocketController.prototype.sendCommand(
      "userRegister",
      newUserDetails,
      true
    );

    // const response = {
    //   status: 200, // Simulated response for testing
    //   data: {
    //     message: "Registration successful",
    //   },
    // };

    if (response && response.status !== undefined && response.status !== null) {
      console.log(response);
      if (response.status === 200 || response.status === 202) {
        return { rStatus: "success" };
      } else if (response.status === 0) {
        console.log("Registration Error - Network Error or Timeout");
        return {
          rStatus: "error",
          rData: i18n.t("Registration Timeout Error"),
        };
      } else if (response.status === 400) {
        console.log("Registration Error - Request Error");
        return { rStatus: "error", rData: i18n.t("Registration Error") };
      } else if (response.status === 500) {
        console.log("Registration Error - Server Error");
        return {
          rStatus: "error",
          rData: i18n.t("Registration Support Error"),
        };
      } else {
        console.log(
          "Registration Error - Unknown Error. status:",
          response.status
        );
        return { rStatus: "error", rData: i18n.t("Registration Error") };
      }
    } else {
      console.log(
        "Error occurred during registration - no response received / incorrect response format"
      );
      return {
        rStatus: "error",
        rData: i18n.t("Registration Support Error"),
      };
    }
  } catch (error) {
    console.error("Registration Error has occurred as:", error);
    return { rStatus: "error", rData: i18n.t("Registration Support Error") };
  }
}
